module.exports = __webpack_public_path__ + "img/hz-xdkf.df976553.png";